import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApplicationTypes } from 'projects/admin/src/app/models/exemptionFilling';
import { forkJoin } from 'rxjs';
import { ConfirmModalComponent } from '../shared/component/confirm-modal/confirm-modal.component';
import { ExternalFilingRequestService } from '../shared/services/exemptionFilingRequest';
import { ExternalCommonService } from '../shared/services/external.common.service';

@Component({
  selector: 'app-registration-details',
  templateUrl: './registration-details.component.html',
  styleUrls: ['./registration-details.component.scss'],
})
export class RegistrationDetailsComponent implements OnInit {
  @Input() historyData: any;
  @Input() exemptionData: any;
  @Output() retunToSearch = new EventEmitter();
  pendingInternalStatus: any;
  pendingExternalStatus: any;
  requestTypes: any;
  isLinkClicked = false;
  isRequestCopyLinkClicked = false;
  constructor(
    private commonService: ExternalCommonService,
    private routerService: Router,
    private exemptionFilingRequestService: ExternalFilingRequestService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    forkJoin({
      reqType: this.commonService.getRequestTypes(),
      reqT: this.commonService.getRequestStatusTypes(),
      externalT: this.commonService.getExternalStatusTypes(),
    }).subscribe(({ reqT, externalT, reqType }) => {
      this.requestTypes = reqType;
      this.pendingInternalStatus = reqT.find(
        (x: { code: string }) => x.code == 'PENDING'
      )?.id;
      this.pendingExternalStatus = externalT.find(
        (x: { code: string }) => x.code == 'PENDING'
      )?.id;
    });
  }
  returnSearch() {
    this.retunToSearch.emit();
  }
  fileRenewal() {
    this.isLinkClicked = true;
    const reqTypeid = this.requestTypes.filter(
      (x: { code: ApplicationTypes; }) => x.code == ApplicationTypes.RenewalApplication
    )[0].id;
    if (this.exemptionData?.registrationControlNumber.length > 0) {
      this.exemptionFilingRequestService
        .getExistingExemptionFilingRequest(
          this.exemptionData?.registrationControlNumber
        )
        .subscribe(
          (res) => {
            console.log(res);
            if (res && res.length > 0) {
              if (res[0].expiresIn60Days == false) {
                this.dialog.open(ConfirmModalComponent, {
                  data: {
                    title: 'Warning',
                    warning: true,
                    message: `A Renewal can only be filed within 60 days of the registration expiration date.`,
                  },
                  disableClose: true,
                });
              } else {
                this.exemptionFilingRequestService
                .addToExistingExemptionFilingRequest(
                  res[0].id,
                  reqTypeid,
                  this.pendingInternalStatus,
                  this.pendingExternalStatus
                )
                .subscribe(
                  (data) => {
                    console.log(data);
                    if (data && data?.id) {
                      this.routerService.navigate(['/renewal', btoa(data?.id)]);
                    }
                  },
                  (error) => {
                    console.log(error);
                  }
                );
              }

            } else {
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }
  fileRequestCopy() {
    this.isRequestCopyLinkClicked = true;
    const reqTypeid = this.requestTypes.filter(
      (x: { code: ApplicationTypes; }) => x.code == ApplicationTypes.RequestaCopy
    )[0].id;
    // this.routerService.navigate(['create', 'cmVxdWVzdGNvcHk=']);
    if (this.exemptionData?.registrationControlNumber.length > 0) {
      this.exemptionFilingRequestService
        .getExistingExemptionFilingRequest(
          this.exemptionData?.registrationControlNumber
        )
        .subscribe(
          (res) => {
            console.log(res);
            if (res && res.length > 0) {
              this.exemptionFilingRequestService
                .addToExistingExemptionFilingRequest(
                  res[0].id,
                  reqTypeid,
                  this.pendingInternalStatus,
                  this.pendingExternalStatus
                )
                .subscribe(
                  (data) => {
                    console.log(data);
                    if (data && data?.id) {
                      this.routerService.navigate(['/requestcopy', btoa(data?.id)]);
                    }
                  },
                  (error) => {
                    console.log(error);
                  }
                );
            } else {
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }
  onPrint() {
    this.exemptionFilingRequestService
      .getPrintDoc(this.exemptionData.id)
      .subscribe((doc: any) => {
        this.openFile(doc);
      });
  }

  private openFile = (data: any) => {
    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], { type: 'application/pdf' });
    var url = window.URL.createObjectURL(blob);
    window.open(url, '_blank', '');
  };
}
